import React, { useEffect } from 'react';
import { string, bool } from 'prop-types';
import {
  params, shape, arrayOf,
  namedFragment, typename,
  string as stringType, customType
} from '@thd-nucleus/data-sources';
import { ImpressionProvider } from '@thd-olt-component-react/impression';
import { RichTextWrapper } from './subcomponents/RichTextWrapper';
import { ImageWrapper } from './subcomponents/ImageWrapper';
import { useNewspaper } from '../hooks/useNewspaper';

const NewspaperModule = ({
  componentId,
  componentClass,
  lazyLoad = false,
  livePreviewData = null
}) => {
  useEffect(() => {
    LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('newspaper-module.ready');
  }, []);

  const {
    hasData,
    ref,
    clickID,
    displayScenario,
    imageRenderObj,
    richTextObj
  } = useNewspaper({
    componentId,
    componentClass,
    livePreviewData
  });

  if (!hasData) {
    return null;
  }

  return (
    <ImpressionProvider
      data={{
        id: componentId,
        name: 'NewspaperModule',
        component: 'NewspaperModule',
        type: 'content'
      }}
    >
      <div
        className="sui-grid sui-grid-cols-12"
        data-component="NewspaperModule"
        ref={ref}
        /* eslint-disable-next-line react/no-unknown-property */
        clickid={clickID}
      >
        {richTextObj?.richText && (
          <RichTextWrapper
            richTextObj={richTextObj}
            componentId={componentId}
            isLivePreview={!!livePreviewData}
          />
        )}
        <ImageWrapper
          imageRenderObj={imageRenderObj}
          componentId={componentId}
          fieldId={`${displayScenario}Image`}
          lazyLoad={lazyLoad}
        />
      </div>
    </ImpressionProvider>
  );
};

NewspaperModule.propTypes = {
  componentId: string.isRequired,
  componentClass: string.isRequired,
  lazyLoad: bool,
  livePreviewData: shape({})
};

NewspaperModule.displayName = 'NewspaperModule';

// Do not touch
const DamMediaFragment = namedFragment({
  inline: false,
  fragmentType: 'DamMedia',
  fragmentAlias: 'DamMediaV1'
}).shape({
  damContentSelector: shape({
    assetData: arrayOf(
      shape({
        selectedImageUrl: stringType()
      })
    )
  }),
  damDownloadedContent: shape({
    url: stringType()
  }),
  id: stringType(),
  __typename: typename('DamMedia')
});

NewspaperModule.dataModel = {
  component: params({
    id: stringType().isRequired(),
    componentClass: customType('ComponentClass').enum(['Newspaper']).isRequired()
  }).shape({
    Newspaper: namedFragment({
      inline: true,
      fragmentType: 'Newspaper'
    }).shape({
      id: stringType(),
      altText: stringType(),
      link: stringType(),
      description: stringType(),
      damImageAlignmentBehavior: stringType(),
      damImageWidthBehavior: stringType(),
      descriptionAlignment: stringType(),
      desktopImage: DamMediaFragment,
      tabletImage: DamMediaFragment,
      mobileImage: DamMediaFragment
    })
  })
};

export { NewspaperModule };
